export default "__VITE_PUBLIC_ASSET__ae13aaff__"